export enum HistoryActionTypes {
  UNDO,
  REDO
}
